export function formatMoney(value: number): string {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatPrice(value: number, precision = 2): string {
  if (precision >= 4) {
    return value.toLocaleString('en-US', {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    });
  }
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatPct(value: number): string {
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}%`;
}

export function formatQty(value: number): string {
  return value.toLocaleString('en-US', { maximumFractionDigits: 4 });
}

export function formatCompact(value: number): string {
  return value.toLocaleString('en-US', { notation: 'compact', maximumFractionDigits: 1 });
}

export function formatWhen(iso: string): string {
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(iso));
}

export function assetLabel(assetClass: string): string {
  switch (assetClass) {
    case 'EQUITY':
      return 'Equity';
    case 'INDEX':
      return 'Index';
    case 'CRYPTO':
      return 'Crypto';
    case 'FX':
      return 'FX';
    case 'COMMODITY':
      return 'Metal';
    default:
      return assetClass;
  }
}
